module.exports = __webpack_public_path__ + "media/images/banner/becos/crowdfundingBannerV2-56a0809b88fb34e8498363876742e960.jpeg";